import { TASA_BULK_LEVELS, TasaBulkLevel } from './tasas-bulk.model';

/** Alcance del gestor TPV (mismo vocabulario que `UserRoleService.getTpvScopeLevel()`). */
export type TpvScope = 'FATHER' | 'EMPRESA' | 'UNIDAD_NEGOCIO' | 'COMERCIO' | null;

/**
 * Niveles de la carga masiva de comisiones que el usuario puede usar (R3, R6):
 * el permiso de cada nivel, recortado por el alcance del gestor con la MISMA
 * matriz que el sidebar ("nivel asignado y hacia abajo"): un alcance COMERCIO no
 * ve Empresas ni Unidades; uno UNIDAD_NEGOCIO no ve Empresas. Sin alcance
 * declarado (payload viejo) no se recorta. En el orden canónico de las pestañas.
 *
 * El back sigue siendo la autoridad (R40): esto solo evita ofrecer lo que
 * respondería 403.
 */
export function allowedTasaBulkLevels(
  can: Readonly<Record<TasaBulkLevel, boolean>>,
  scope: TpvScope,
): TasaBulkLevel[] {
  return TASA_BULK_LEVELS.filter((level) => {
    if (!can[level]) return false;
    if (scope === 'COMERCIO') return level === 'merchant';
    if (scope === 'UNIDAD_NEGOCIO') return level !== 'company';
    return true;
  });
}
